module.exports = __webpack_public_path__ + "static/media/39_Presidential_Cell.9b751794.JPG";